import {
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "@tanstack/react-query";
import {
  PostAllCBSNsList,
  PostAllSerialNumbers,
} from "../../api/api";
import { useState } from "react";

type GetSerialNumbersList = {
  open: boolean;
  authToken: string;
  chassisSerialNo: string;
};

type chassisSerialNo = {
  chassisSerialNo: string;
  // isDefaultTag: boolean;
  // occurrence: number;
};

type SerialNumbersList = {
  status: string;
  msg: chassisSerialNo[];
};

export const useListSerialNumbers = ({
  open,
  authToken,
  chassisSerialNo,
}: GetSerialNumbersList): UseInfiniteQueryResult<
  SerialNumbersList,
  Error
> => {
  const [totalCount, setTotalCount] = useState(0);
  let limit = 25;

  return useInfiniteQuery({
    queryKey: [
      "listChassisSerialNumbers",
      open,
      authToken,
      chassisSerialNo,
    ],
    initialPageParam: { skip: 0, limit },
    staleTime: 1000 * 60 * 5,
    queryFn: ({
      pageParam,
    }: {
      pageParam: { skip: number; limit: number };
    }) =>
      PostAllSerialNumbers({
        authToken,
        body: {
          device: pageParam,
          filter: {
            chassisSerialNo: chassisSerialNo,
          },
        },
      }).then((res) => {
        setTotalCount(res?.count);
        return res;
      }),
    enabled: !!authToken && !!open,
    getNextPageParam: (
      lastPage: SerialNumbersList,
      allPages: SerialNumbersList[]
    ) => {
      const totalFetched = allPages.flatMap(
        (page) => page.msg
      ).length;

      // Stop fetching if the total fetched rows reach or exceed the total count
      if (totalFetched >= totalCount) {
        return undefined;
      }

      // Return the skip value for the next page
      return { skip: allPages.length * limit, limit };
    },
  });
};
